export default "__VITE_ASSET__BX5oYaB2__"